<template>
  <div>
    <div>
      <h1>{{ accountName }}</h1>
      <div class="line"></div>
      <h5>Email Address</h5>
      <p>{{ userDetails.email_address }}</p>
    </div>
    <div>
      <p>Update your profile and start creating cards!</p>
      <h5 @click="showProfileForm()">Setup your profile</h5>
    </div>
    <div>
      <p>Unlock other exciting features by getting verified.</p>
      <a href="/verify-account">Get Verified</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountName: String,
    userDetails: Object,
    showProfileForm: Function
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/individual_profile/ProfileNotVerified.vue